// extracted by mini-css-extract-plugin
export default {"container":"ingredient-details_container__9P06E","data":"ingredient-details_data__PKZN1"};